import { render, staticRenderFns } from "./IBSidebar.vue?vue&type=template&id=abf83a48&scoped=true"
import script from "./IBSidebar.vue?vue&type=script&lang=js"
export * from "./IBSidebar.vue?vue&type=script&lang=js"
import style0 from "./IBSidebar.vue?vue&type=style&index=0&id=abf83a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf83a48",
  null
  
)

export default component.exports